import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Modal from "@mui/material/Modal"
import CloseIcon from "@mui/icons-material/Close"
import { ButtonContainer, CancelButton, ConfirmButton, ModalHeader } from "./Atom"
import { modalContainerStyles } from "../Atom"

const MetricBlueprintAssignConfirmation = ({
  open,
  handleClose,
  handleAssignMetrics,
}: any) => {

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalContainerStyles}>

        <ModalHeader
        >
          <CloseIcon
            sx={{ marginRight: "10px", marginTop: "10px", cursor: "pointer" }}
            onClick={() => {
              handleClose()
            }}
          />
        </ModalHeader>

        <Typography
          id="modal-modal-title"
          fontSize={"18px"}
          fontWeight={500}
          sx={{ padding: "10px 10px 30px 10px", textAlign: "center", borderBottom: "1px solid grey" }}
        >
          Are you sure to assign selected metrics to the selected groups?
        </Typography>

        <br />

        <ButtonContainer
        >
          <CancelButton
            onClick={() => handleClose()}
          >
            <Typography color={"#4A79E7"}>Cancel</Typography>
          </CancelButton>
          <ConfirmButton
            onClick={() => {
              handleAssignMetrics()
              handleClose()
            }}
          >
            <Typography color={"#ffffff"}>Yes</Typography>
          </ConfirmButton>
        </ButtonContainer>
      </Box>
    </Modal>
  )
}

export default MetricBlueprintAssignConfirmation
